<template>
  <el-dialog
    :title="this.type != 'new' ? $t('app.edit') : $t('app.new')"
    :visible.sync="dialogVisible"
    width="400px"
  >
    <el-input
      v-model="code"
      :disabled="this.type != 'new'"
      style="margin-bottom: 20px"
      :placeholder="$t('app.floorCode')"
    >
    </el-input>
    <el-input
      v-model="name"
      :placeholder="$t('app.floorName')"
      style="margin-bottom: 20px"
    >
    </el-input>
    <el-select
      v-model="gender"
      :placeholder="$t('app.gender')"
      style="width: 100%; margin-bottom: 20px"
    >
      <el-option label="男" :value="'M'"> </el-option>
      <el-option label="女" :value="'F'"> </el-option>
    </el-select>
    <el-input-number
      size="small"
      v-model="sort"
      :min="1"
      :max="99"
      label="樓層排序"
      style="width: 100%;"
    ></el-input-number>
    <el-checkbox
      v-model="isSupportGuest"
      style="padding-top: 1rem; padding-bottom: 1rem"
      >訪客專供</el-checkbox
    >
    <span slot="footer" class="dialog-footer">
      <el-button size="small" type="info" @click="dialogVisible = false">{{
        $t("app.cancel")
      }}</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="loading"
        @click="handleClose"
        >{{ $t("app.confirm") }}</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import { editFloor, addFloor } from "@/api/systemManagement/roomManagement";
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      code: "",
      name: "",
      type: "",
      gender: "",
      isSupportGuest: false,
      sort: "",
    };
  },
  methods: {
    edit(row) {
      console.log(row)
      this.dialogVisible = true;
      this.code = row.code;
      this.name = row.name;
      this.gender = row.gender;
      this.isSupportGuest = row.isSupportGuest;
      this.type = "edit";
      this.sort = row.sort;
    },
    new() {
      this.dialogVisible = true;
      this.type = "new";
      this.code = "";
      this.name = "";
      this.gender = "";
      this.isSupportGuest = false;
      this.sort = "";
    },
    handleClose() {
      this.$confirm(
        (this.type === "edit"
          ? this.$t("app.confirmModification")
          : this.$t("app.confirmAdd")) + "?"
      ).then(() => {
        this.loading = true;
        if (this.type === "edit") {
          editFloor({
            FloorCode: this.code,
            FloorName: this.name,
            Gender: this.gender,
            IsSupportGuest: this.isSupportGuest,
            Sort: this.sort,
          })
            .then(() => {
              this.success();
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          addFloor({
            FloorCode: this.code,
            FloorName: this.name,
            Gender: this.gender,
            IsSupportGuest: this.isSupportGuest,
            Sort: this.sort,
          })
            .then(() => {
              this.success();
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
    success() {
      this.$message({
        message: this.$t("app.opeSuccess"),
        type: "success",
      });
      if (this.type === "edit") {
        this.$emit("handleSuccess", {
          code: this.code,
          name: this.name,
          gender: this.gender,
          isSupportGuest: this.isSupportGuest,
          sort: this.sort,
        });
      } else {
        this.$emit("handleAdd", {
          code: this.code,
          name: this.name,
          gender: this.gender,
          isSupportGuest: this.isSupportGuest,
          sort: this.sort,
        });
      }
      this.loading = false;
      this.dialogVisible = false;
    },
  },
};
</script>
